import { HttpErrorResponse } from '@angular/common/http';
import { ProductSettingsDTO } from '@modeso/types__dgoods-products';
import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import * as ProductsActions from '../actions/products.actions';
import { productSettingsReducers } from './product-settings.reducer';

export interface ProductsState {
    productsSettings: EntityState<ProductSettingsDTO>;
    loading: boolean;
    error: HttpErrorResponse | null;
    success: boolean;
}

export const productSettingsAdapter: EntityAdapter<ProductSettingsDTO> = createEntityAdapter<ProductSettingsDTO>({
    selectId: (productSetting: ProductSettingsDTO) => productSetting.productLineName,
});

export const initialState: ProductsState = {
    error: null,
    loading: false,
    productsSettings: productSettingsAdapter.getInitialState(),
    success: false,
};

export const productsReducer = createReducer(
    initialState,

    ...productSettingsReducers,

    on(ProductsActions.clearProductsState, (state: ProductsState) => ({
        ...state,
        productSettings: productSettingsAdapter.getInitialState(),
        loading: false,
        error: null,
        success: false,
    })),

    on(ProductsActions.clearRequestState, (state: ProductsState) => ({
        ...state,
        loading: false,
        error: null,
        success: false,
    })),
);
